import useFetch from '@hooks/useFetch';

const defaultTopicsLevel = 30;

export const getKey = (batchUID) =>
  `v1/batch/${batchUID}/topics/?level=${defaultTopicsLevel}`;

const useBatchTopicsCovered = (batchUID) => {
  const key = getKey(batchUID);

  const { data: topicsCovered, ...rest } = useFetch(batchUID ? key : null);

  return { key, topicsCovered, ...rest };
};

export default useBatchTopicsCovered;
